export * from './CollectJS.script';
